import sal from "sal.js";

export default (element) => {
    sal({
        selector: `.${element.firstChild.className}`,
        threshold: 0.2
    });

    const salResourceBanner = document.querySelector(`.${element.firstChild.className}`);

    salResourceBanner.addEventListener('sal:in', () => {
        document.querySelector('.box-section [data-animated-arrow="bottom"]').classList.add('sal-animate');
    });
};